import { CART_NAME } from "./cart";
import {
  LOCATION_DELIVERY_NAME,
  removeLocalStorageByName,
  removeProductInProductsLocationDeliveryStoreById,
} from "./location";

export const removeProductInLocalCart = (id: number) => {
  let localCart = localStorage.getItem("cart");
  if (localCart) {
    let localCartParsed: LocalCartItem[] = JSON.parse(localCart);

    let updateItemIndex = localCartParsed.findIndex(
      item => item.productId === id,
    );

    if (updateItemIndex > -1) {
      localCartParsed.splice(updateItemIndex, 1);
      removeProductInProductsLocationDeliveryStoreById(id);
      if (localCartParsed.length) {
        localStorage.setItem("cart", JSON.stringify(localCartParsed));
      } else {
        removeLocalStorageByName(CART_NAME);
        removeLocalStorageByName(LOCATION_DELIVERY_NAME);
      }
    }
  }
};

export const LAST_ADD_TO_CART_PRODUCT_ITEM_NAME = "lastAddToCartProductItem";
export const setLastAddtocartProductItem = (id: number) =>
  localStorage.setItem(LAST_ADD_TO_CART_PRODUCT_ITEM_NAME, String(id));
export const getLastAddtocartProductItem = () =>
  localStorage.getItem(LAST_ADD_TO_CART_PRODUCT_ITEM_NAME);
export const resetLastAddtocartProductItem = () =>
  localStorage.setItem(LAST_ADD_TO_CART_PRODUCT_ITEM_NAME, "");
export const removeLastAddtocartProductItem = () =>
  localStorage.removeItem(LAST_ADD_TO_CART_PRODUCT_ITEM_NAME);

export default {};
